import React, { useState, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { userValidate, urlUserValidate, getUser, urlGetUser } from "~/api/getUser";
// import axios, { axiosAuth } from "react-axios";
import axios from "react-axios";
import { LOCAL_STORE_JWT } from "../../../utils/main";
import { useUser } from "~/Context/userContext";

const Auth = (props) => {
  const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
  const [loading, setLoading] = useState(true);
  const { state: userState, dispatch } = useUser();

  const loadDataOnlyOnce = async () => {
    // use php validate for now since its stable api
    await userValidate(axios, urlUserValidate, { jwt })
      .then(({ data }) => {
        // console.log("*******Auth urlUserValidate:", data);
        if (!data.success) {
          // console.log("*******Auth urlUserValidate: success FALSE");
          // @TODO this makes the jwt was not set or invalid
          // should redirect user to reauth page
          throw new Error("User not validated");
        }
        // console.log("data:", data);
        return data;
      })
      .then(({ isChim, user }) => {
        // console.log("*******Auth isChim:", isChim);
        // console.log("*******Auth loadDataOnlyOnce user:", user);
        if (isChim === false) {
          dispatch({ type: "user_login", payload: { user } });
        } else {
          dispatch({ type: "login", payload: { user } });
        }
        return;
        // return getUser(axios, urlGetUser, { chimdir: user.dir }).then(({ data }) => {
        //   console.log("*******Auth getUser:", data);
        //   // {
        //   // success: true,
        //   // chim: {chim_dir: "ryan", chim_id: "31", full_name: "Ryan"}
        //   // }
        //   return new Promise(function (resolve, reject) {
        //     if (data.success) {
        //       dispatch({ type: "login", payload: { chim: data.chim } });
        //     } else {
        //       console.log("*******Auth getUser: fail");
        //       dispatch({ type: "fail", payload: {} });
        //     }
        //     resolve();
        //   });
        // });
      })
      .then(() => setLoading(false))
      .catch((e) => {
        console.log("*******Auth urlUserValidate: axios: FALSE");
        setLoading(false);
      });
  };
  useEffect(() => {
    if (jwt) {
      loadDataOnlyOnce();
    } else {
      setLoading(false);
      dispatch({ type: "anonymous", payload: {} });
    }
  }, []);

  if (loading) {
    return <Spinner animation="border" style={{ display: "block", margin: "10px auto" }} variant="dark" />;
  }
  return <div>{props.children}</div>;
};

export default Auth;
